import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Are you ready to ride the tsunami of change that is coming?" />

                      
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/&amp;title=Are%20you%20ready%20to%20ride%20the%20tsunami%20of%20change%20that%20is%20coming%3F&amp;summary=Are%20you%20ready%20to%20ride%20the%20tsunami%20of%20change%20that%20is%20coming%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Are%20you%20ready%20to%20ride%20the%20tsunami%20of%20change%20that%20is%20coming%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Are%20you%20ready%20to%20ride%20the%20tsunami%20of%20change%20that%20is%20coming%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header header--video" id="page-header">
    <div className="header__image" data-video-uri="https://www.youtube.com/embed/NGVgs0KYVU0?autoplay=1&amp;modestbranding=0&amp;rel=0&amp;showinfo=0" data-video-target="#page-header .embed-responsive" data-video-parent="#page-header">
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>Sales careers</h3>
                        <h1>Are you ready to ride the tsunami of change that is coming?</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>8 November 2016</li>
                        <li>4:14</li>
                    </ul>
                    <div className="header__icon play-icon">
                        <i className="icon"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Sales people (and vendor organisations) need to transform radically to survive a tsunami of change that is coming.</h3>
<div className="rich-text"><p>The breakdown of duties performed by B2B sales people is now changing rapidly and, when you consider that we have seen very little substantive change since 1884, it’s actually quite amazing where the role of the B2B sales person is now headed.</p><p>We are now witnessing a raft of new tools and technology platforms being used by marketers to engage buyers at various stages of the new buying journey. Content and automated marketing, inbound and outbound programs are all designed to improve the development, management and nurturing of those all-important leads. Top-of-the-funnel and pipeline development is gradually going the way of marketing professionals, meaning that the role that the sales person has traditionally played is being diluted or eroded.</p><p>Are you ready for this new 'customer-pull' era of sales? </p></div>


  <button type="button" className="btn btn-default" data-toggle="collapse" data-target="#transcript" aria-expanded="false" aria-controls="transcript">View full transcript</button>
  <div className="collapse" id="transcript">
  <h3>Transcript</h3>
  <div className="block-paragraph"><div className="rich-text"><p><b>John:   </b>         I’ve got Graham Hawkins with me again – welcome back, Graham!</p><p><b>Graham:   </b>     Thanks, John – good to be here!</p><p><b>John: </b>           Graham, you’ve written a great book – that’s one of the reasons we’re together, talking – <i>Sales Transformation</i> you titled it.</p><p><b>Graham:</b>        Yes.</p><p><b>John: </b>           You talk about some controversial things that are happening in the marketplace that most sales organisations are not responding to, and you say they need to, they need to transform quite radically if they’re going to survive in the future.</p><p><b>Graham:   </b>     Correct.</p><p><b>John:   </b>         Tell me why.</p><p><b>Graham:  </b>      It’s interesting, John. I’ve been in sales for 27 years, sales leadership roles, and…</p><p><b>John:     </b>       You’re obviously a lot younger than you look.</p><p><b>Graham:   </b>     [laughs] Yes, I’ve been around the game for a while, but I’ve never seen in my career the amount of change that we’re witnessing right now, and the sort of change that you’ve been talking about with your Masterminds, the sort of things that we’re talking about are the new buying journey, the way buyers create and come to market with opportunities. More importantly, we’ve gone from what I call vendor push models to customer pull.</p><p><b>John:   </b>         And yet a lot of vendors are still trying to push, right?</p><p><b>Graham:   </b>     Correct, a lot of those old methodologies and the old approach to selling still persist today. Where I’m getting to with the book is because of the way buyers are changing the way they buy, salespeople must adapt and must adapt pretty quickly. When you think about things like the pressure on customers to do more business with less vendors, when you look at the maturity of the market – particularly in the high tech base, which is where I’m from – mature markets’ common traits are always based around things like high levels of competition, low barriers to entry.</p><p><b>John:     </b>       Commodity-based products…</p><p><b>Graham: </b>       Commodity products, yes, downward pressure on pricing. But most importantly, in mature markets you have highly educated and sophisticated customers. Everyone keeps saying it, today’s customers and buyers have more access to more information than at any time in the past. What does that mean? Well, it means that salespeople have to lift their game and they have to transform the way they go to market.</p><p><b>John: </b>           It’s more than just life their game, surely. From what you’re saying and what I’ve read in the book, it’s actually change the game, change totally the way you think about how you work with customers and how you go through the sales processes and so on. True?</p><p><b><Link to="knowledge-centre/insights/strategicsellinggroup.com/wp-content/uploads/2016/07/Transform8-2.jpg"><br/></Link>Graham: </b>       Yes, correct. Look, if you read some of the analysts like Forrester, they’re saying that by 2020 a quarter of the salespeople currently in B2B sales roles today will be redundant. When you look at artificial intelligence, robotics, machine learning, all the technology enablers, we’re seeing a totally different way of selling these days, based on the way buyers want to buy. So you’re right, salespeople must transform, they must become much more sophisticated.</p><p><b>John:  </b>          Can salespeople do that on their own? They really need the organisation to put the new processes and new thinking together, and transform as an organisation, the way they interact with customers, the way they work in the sales process.</p><p><b>Graham:     </b>   Correct, yes.</p><p><b>John:   </b>         Okay. So transformation’s going to be a big topic over the next decade or so, maybe even in the shorter period.</p><p><b>Graham:       </b> Absolutely.</p><p><b>John:       </b>     So, what does it mean, transformation? How do we transform? It’s a big subject, isn’t it?</p><p><b>Graham: </b>       It’s a huge subject. If you go back to the basics, salespeople and sales leaders have to stop tracking the sales cycle and start tracking the buying journey. You’ve got to understand what the customers want in terms of buyers, understanding that they’re under pressure to do more business with less vendors, and really start to understand how the customer needs to buy your product, that’s where it all starts. And for those salespeople that want to continue doing business the old way, they’re gradually going to be marginalised.</p><p><b>John:   </b>         Yes, and customers won’t see them bringing any value to the table; they can find a product or a service or whatever without having a salesperson involved.</p><p><b>Graham:  </b>      Correct.</p><p><b>John: </b>           Okay. Graham, I’d like to talk much more about the transformation that we need to go through in each area that we need to address. Would you come back and talk more with us?</p><p><b>Graham:</b>        Happy to, yes.</p><p><b>John:  </b>          Look forward to it!</p><p><b>Graham: </b>       Thanks, John!</p></div></div>
  </div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/&amp;title=Are%20you%20ready%20to%20ride%20the%20tsunami%20of%20change%20that%20is%20coming%3F&amp;summary=Are%20you%20ready%20to%20ride%20the%20tsunami%20of%20change%20that%20is%20coming%3F&amp;source=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Are%20you%20ready%20to%20ride%20the%20tsunami%20of%20change%20that%20is%20coming%3F&amp;url=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Are%20you%20ready%20to%20ride%20the%20tsunami%20of%20change%20that%20is%20coming%3F&amp;body=https%3A//salestribe.com/knowledge-centre/insights/are-you-ready-ride-tsunami-change-coming/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/7-laws-sales-success" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-ideas-announcement.jpg" className="card__image" height="404" src="../../../media/images/article-ideas-announcement_6oOJESq.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Sales careers</p>
                        <h3 className="card__title"><strong>The 7 Laws of Sales Success</strong></h3>
                    </header>
                    <p>There are certain &quot;Laws&quot; of the universe which successful people often leverage, and today&#39;s&#39; sales people must learn to embrace some of these important laws to ensure future sales success.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-outreach-destroying-your-career" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-challenge-yell.jpg" className="card__image" height="404" src="../../../media/images/article-challenge-yell_YbkW7pV.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Sales careers</p>
                        <h3 className="card__title"><strong>Is sales Outreach destroying your Career?</strong></h3>
                    </header>
                    <p>If you are still performing 20th century outreach tactics like &quot;cold calling&quot; then you are not just destroying your own career, but you are also destroying your employers brand and therefore their business.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/extrovert-introvert-rethinking-sales-priorities" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-challenge-juggle.jpg" className="card__image" height="404" src="../../../media/images/article-challenge-juggle_PUKUKDN.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Sales careers</p>
                        <h3 className="card__title"><strong>From extrovert to introvert: Rethinking sales priorities</strong></h3>
                    </header>
                    <p>What is the profile of a modern sales person?

This article was written by Graham Hawkins and it first appeared on the Salesforce Blog in July 2018:</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 